<app-navbar-control></app-navbar-control>

<div class="document-details">

  <div ngbAccordion class="mt-3">
    @for (topic of document.topics; track topic) {
    <div ngbAccordionItem [collapsed]="false">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>{{topic.title}}</button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <div ngbAccordion>
              @for (subtopic of topic.subtopics; track subtopic) {
              <div ngbAccordionItem [collapsed]="false">
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton>{{subtopic.title}}</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <div [innerHTML]="replace(subtopic.description)"></div>
                    </ng-template>
                  </div>
                </div>
              </div>
              }
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    }
  </div>
</div>